
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import layout from '@/layout/page-with-header'
import ListTable from './ListTable'
import EntryDialog from './EntryDialog'
const components = {
  layout,
  ListTable,
  EntryDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = {
  ...mapGetters({
    isLoading: `Customer/Group/loadingState`,
  }),
}

/**
 * Methods
 *
 */
const methods = mapActions({
  reload: `Customer/Group/fetchList`,
})

methods.addNewRecord = function() {
  this.$refs.EntryDialog.new()
}

methods.editRecord = function(id) {
  this.$router.push(`/customer/group/${id}`)
}

/**
 * Event OnMounted
 *
 */
const mounted = function() {
}

/**
 * Event OnCreated
 *
 */
const created = function() {
  this.$store.commit(`set_page_title`, `Kasir`)
  this.$store.commit(`set_breadcrumb`, [ `Grup Pelanggan`, `List` ])
}

export default {
  components,
  data,
  computed,
  methods,
  mounted,
  created,
}
</script>

<style scoped>
</style>

<template>
  <layout>
    <Row>
      <BlockTable :loading="isLoading">
        <template #header>
          Daftar Kurir Toko

          <ButtonR text="Tambah Record" color="primary" @click="addNewRecord" />
          <ButtonR icon="repeat" color="default" @click="reload" />
        </template>
        <template #content>
          <ListTable @editrequest="editRecord" />
        </template>
      </BlockTable>
    </Row>

    <EntryDialog ref="EntryDialog"
      @success="editRecord"
    />
  </layout>
</template>